
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Plus, Building } from 'lucide-react';
import { getOrganizations } from '@/services/organizationService';
import { OrganizationsTable } from '@/components/admin/organizations/OrganizationsTable';
import { CreateOrganizationDialog } from '@/components/admin/organizations/CreateOrganizationDialog';
import { OrganizationsStats } from '@/components/admin/organizations/OrganizationsStats';

export default function Organizations() {
  const [createDialogOpen, setCreateDialogOpen] = useState(false);

  const { 
    data: organizations = [], 
    isLoading, 
    refetch 
  } = useQuery({
    queryKey: ['organizations'],
    queryFn: getOrganizations,
  });

  const handleOrganizationCreated = () => {
    refetch();
    setCreateDialogOpen(false);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-pulse text-primary">Loading organizations...</div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Organizations</h1>
          <p className="text-muted-foreground">
            Manage organizations and their team members
          </p>
        </div>
        <Button onClick={() => setCreateDialogOpen(true)}>
          <Plus className="mr-2 h-4 w-4" />
          Create Organization
        </Button>
      </div>

      <OrganizationsStats organizations={organizations} />

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Building className="h-5 w-5" />
            Organizations
          </CardTitle>
        </CardHeader>
        <CardContent>
          <OrganizationsTable 
            organizations={organizations} 
            onOrganizationUpdated={refetch}
          />
        </CardContent>
      </Card>

      <CreateOrganizationDialog
        open={createDialogOpen}
        onOpenChange={setCreateDialogOpen}
        onOrganizationCreated={handleOrganizationCreated}
      />
    </div>
  );
}
